module.exports = __webpack_public_path__ + "static/media/button-arrow.e3189395.svg";